<template>
    <div>
        <v-container fluid>
            <v-row>
                <v-col>
                    <h2 v-text="this.editing ? this.$route.params.id : 'Nueva'"></h2>
                </v-col>
            </v-row>
            <v-row align="center">
                <v-col md="3">
                    <v-text-field v-model="currentBase.cod_base" :rules="[(v) => !!v || 'Código es necesario']"
                        label="Código" required>
                    </v-text-field>
                </v-col>
                <v-col>
                    <v-text-field v-model="currentBase.descripcion" :rules="[(v) => !!v || 'Descripción es necesario']"
                        label="Descripción" required>
                    </v-text-field>
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <v-autocomplete v-model="model_utilidad" :items="utilidades" label="Utilidad" prepend-icon="mdi-tools"
                        item-text="nombre" item-value="id_utilidad" multiple return-object chips>

                        <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.item.id_utilidad" close @click="data.select"
                                @click:close="removeUtilidad(data.item)">
                                {{ data.item.nombre }}
                            </v-chip>
                        </template>

                        <template v-slot:append-outer>
                            <v-dialog v-model="dialogUtilidad" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on">
                                        <v-icon dark>
                                            mdi-plus-outline
                                        </v-icon>
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">Crear Utilidad Nueva</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-form ref="formUtilidad">
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field dense v-model="nuevaUtilidad" outlined>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-form>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeUtilidad">
                                            Cancelar
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="saveUtilidad">
                                            Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>

                    </v-autocomplete>
                </v-col>

                <v-col>
                    <v-autocomplete v-model="currentBase.id_familia" :items="familias" :loading="isLoading"
                        item-text="nombre" item-value="id_familia" label="Familia" return-object chips>

                        <template v-slot:selection="data">
                            <v-chip v-bind="data.attrs" :input-value="data.item.id_familia" close @click="data.select"
                                @click:close="removeFamilia(data.item)">
                                {{ (data.item.nombre) }}
                            </v-chip>
                        </template>

                        <template v-slot:append-outer>
                            <v-dialog v-model="dialogFamilia" max-width="500px">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn class="mx-2" fab dark small v-bind="attrs" v-on="on">
                                        <v-icon dark>
                                            mdi-plus-outline
                                        </v-icon>
                                    </v-btn>
                                </template>

                                <v-card>
                                    <v-card-title>
                                        <span class="text-h5">Crear Familia Nueva</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-form ref="formFamilia">
                                                <v-row>
                                                    <v-col>
                                                        <v-text-field dense v-model="nuevaFamilia" outlined>
                                                        </v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-form>

                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn color="blue darken-1" text @click="closeFamilia">
                                            Cancelar
                                        </v-btn>
                                        <v-btn color="blue darken-1" text @click="saveFamilia">
                                            Guardar
                                        </v-btn>
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </template>
                    </v-autocomplete>

                </v-col>
            </v-row>
            <v-row align="center">
                <v-col md="2">
                    <v-text-field v-model="currentBase.dureza" label="Dureza" prepend-icon="mdi-alpha-d-circle"
                        type="number" clearable />
                </v-col>
                <v-col md="2">
                    <v-text-field v-model="currentBase.densidad" label="Densidad" prepend-icon="mdi-dots-hexagon"
                        type="number" clearable />
                </v-col>
                <v-col md="2">
                    <v-text-field v-model="currentBase.decimales" label="Decimales" type="number" clearable />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentBase.fda" label="FDA" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentBase.green_strength" label="Green Strength" />
                </v-col>
                <v-col md="2">
                    <v-checkbox v-model="currentBase.prioritario" label="Prioritario" />
                </v-col>
            </v-row>
            <v-row>
                <v-col>
                    <template>
                        <v-data-table v-if="equivalenciasBase" :headers="tabla_equivalencias" :items="equivalenciasBase"
                            class="elevation-1" hide-default-footer>
                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Equivalencias</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>

                                    <v-dialog v-model="dialogEquivalencia" max-width="500px">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                                Añadir
                                            </v-btn>
                                        </template>

                                        <v-card>
                                            <v-card-title>
                                                <span class="text-h5">{{ formEquivalenciaTitle }}</span>
                                            </v-card-title>

                                            <v-card-text>
                                                <v-container>
                                                    <v-form ref="formEquivalencia">
                                                        <v-row>
                                                            <v-col>
                                                                <v-autocomplete
                                                                    v-model="editedEquivalenciaItem.cod_base_destino_id"
                                                                    :items="bases" :item-text="getEquivalenciaText"
                                                                    item-value="cod_base" label="Codigo" return-object>
                                                                </v-autocomplete>
                                                            </v-col>
                                                        </v-row>
                                                        <v-row>
                                                            <v-col>
                                                                <v-text-field dense v-model="editedEquivalenciaDosis.origen"
                                                                    :label="currentBase.cod_base" outlined type="number">
                                                                </v-text-field>
                                                            </v-col>
                                                            <v-col>
                                                                <v-text-field dense
                                                                    v-model="editedEquivalenciaDosis.destino"
                                                                    :label="editedEquivalenciaItem.cod_base_destino_id.cod_base ? editedEquivalenciaItem.cod_base_destino_id.cod_base : editedEquivalenciaItem.cod_base_destino_id"
                                                                    outlined type="number">
                                                                </v-text-field>
                                                            </v-col>
                                                        </v-row>
                                                        <div class="mt-3 red--text">{{ errorEquivalencias }}</div>
                                                    </v-form>

                                                </v-container>
                                            </v-card-text>

                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="closeEquivalencia">
                                                    Cancelar
                                                </v-btn>
                                                <v-btn color="blue darken-1" text @click="saveEquivalencia">
                                                    Guardar
                                                </v-btn>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>

                                    <v-dialog v-model="dialogEquivalenciaDelete" max-width="500px">
                                        <v-card>
                                            <v-card-title class="text-h5">¿Estás seguro de borrar la Equivalencia?
                                            </v-card-title>
                                            <v-card-actions>
                                                <v-spacer></v-spacer>
                                                <v-btn color="blue darken-1" text @click="closeEquivalenciaDelete">
                                                    Cancelar
                                                </v-btn>
                                                <v-btn color="blue darken-1" text @click="deleteEquivalenciaItemConfirm">
                                                    Borrar
                                                </v-btn>
                                                <v-spacer></v-spacer>
                                            </v-card-actions>
                                        </v-card>
                                    </v-dialog>
                                </v-toolbar>
                            </template>


                            <template v-slot:item.actions="{ item }">
                                <v-icon small class="mr-2" @click="editEquivalenciasItem(item)">
                                    mdi-pencil
                                </v-icon>
                                <v-icon small @click="deleteEquivalenciasItem(item)">
                                    mdi-delete
                                </v-icon>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
                <v-col md="6" v-if="this.editing">
                    <template>
                        <v-data-table v-if="currentBase.proveedor_base" :headers="tabla_proveedores"
                            :items="currentBase.proveedor_base" class="elevation-1" hide-default-footer>

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Proveedores</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>

            <v-row align="center">
                <v-col align="center">
                    <v-btn v-if="this.editing" color="error" class="mr-2" @click="deleteBase">
                        Borrar
                    </v-btn>

                    <v-btn v-if="this.editing" color="success" @click="updateBase">
                        Actualizar
                    </v-btn>

                    <v-btn v-if="!this.editing" color="success" @click="saveBase">
                        Crear
                    </v-btn>
                </v-col>
            </v-row>

            <v-row v-if="this.editing">
                <v-col>
                    <template>
                        <v-data-table v-if="currentBase.formula_base" :headers="tabla_formulas"
                            :items="currentBase.formula_base" class="elevation-1">

                            <template v-slot:top>
                                <v-toolbar flat>
                                    <v-toolbar-title>Fórmulas con {{ currentBase.cod_base }}</v-toolbar-title>
                                    <v-divider class="mx-4" inset vertical></v-divider>
                                    <v-spacer></v-spacer>
                                </v-toolbar>
                            </template>

                            <template v-slot:item.cod_formula.cod_formula="{ item }">
                                <router-link :to="'/formulas/' + item.cod_formula.cod_formula">{{
                                    item.cod_formula.cod_formula
                                }}</router-link>
                            </template>

                            <template v-slot:item.cod_formula.fda="{ item }">
                                <v-simple-checkbox v-model="item.cod_formula.fda" disabled></v-simple-checkbox>
                            </template>

                        </v-data-table>
                    </template>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
import { mapMutations } from "vuex";
import FamiliasDataService from "@/services/FamiliasDataService";
import BasesDataService from "@/services/BasesDataService";
import UtilidadesDataService from "@/services/UtilidadesDataService";

export default {
    name: "BaseId",
    props: ['id'],
    data() {
        return {
            newBase: null,
            editing: false,
            currentBase: {
                cod_base: "",
                decimales: 0,
                descripcion: "",
                densidad: 0,
                dureza: 0,
                fda: false,
                formula_base: [],
                id_familia: null,
                prioritario: false,
                green_strength: false,
                proveedor_base: [],
                utilidad_base: [],
            },
            isLoading: false,
            familias: [],
            searchFamilias: null,
            tabla_proveedores: [
                { text: "Ref.", value: "cod_proveedor.referencia" },
                { text: "Nombre", value: "cod_proveedor.nombre" },
                { text: "Precio", value: "precio" },
            ],
            tabla_equivalencias: [
                { text: "Origen", value: "cod_base_origen_id" },
                { text: "Dosis", value: "dosis" },
                { text: "Destino", value: "cod_base_destino_id" },
                { text: 'Actions', value: 'actions', sortable: false },
            ],
            tabla_formulas: [
                { text: "Codigo", value: "cod_formula.cod_formula" },
                { text: "Descripción", value: "cod_formula.descripcion" },
                { text: "FDA", value: "cod_formula.fda" },
                { text: "PPC", value: "ppc" },
            ],
            equivalenciasBase: [],
            bases: [],
            errorEquivalencias: "",
            dialogEquivalencia: false,
            dialogEquivalenciaDelete: false,
            dialogFamilia: false,
            nuevaFamilia: "",
            dialogUtilidad: false,
            nuevaUtilidad: "",
            editedEquivalenciaIndex: -1,
            editedEquivalenciaDosis: {
                origen: 0,
                destino: 0,
            },
            editedEquivalenciaItem: {
                "dosis": "0:0",
                "cod_base_origen_id": "",
                "cod_base_destino_id": "",
            },
            defaultEquivalenciaItem: {
                "dosis": "0:0",
                "cod_base_origen_id": "",
                "cod_base_destino_id": "",
            },
            utilidades: [],
            model_utilidad: [],
        };
    },
    methods: {
        ...mapMutations("snackbar", ["setSnack"]),
        getNewBase() {
            delete this.newBase;
            this.newBase = {}
            this.newBase.cod_base = this.currentBase.cod_base;
            this.newBase.decimales = this.currentBase.decimales;
            this.newBase.descripcion = this.currentBase.descripcion;
            this.newBase.dureza = this.currentBase.dureza;
            this.newBase.densidad = this.currentBase.densidad;
            this.newBase.fda = this.currentBase.fda;
            this.newBase.prioritario = this.currentBase.prioritario;
            this.newBase.green_strength = this.currentBase.green_strength;
            this.newBase.id_familia = this.currentBase.id_familia;
        },
        getEquivalenciaText(item) {
            return item.cod_base + " (" + item.descripcion + ")"
        },
        removeFamilia(item) {
            this.currentBase.id_familia = null;
        },
        removeUtilidad(item) {
            for (let i = 0; i < this.model_utilidad.length; i++) {
                const element = this.model_utilidad[i];
                if (element.id_utilidad === item.id_utilidad) {
                    this.model_utilidad.splice(i, 1);
                }
            }
        },
        getBase(id) {
            BasesDataService.get(id)
                .then((response) => {
                    this.currentBase = response.data;
                    // console.log("BASES"); console.log(response.data);
                    if (this.currentBase.utilidad_base.length > 0) {
                        for (const element of this.currentBase.utilidad_base) {
                            this.model_utilidad.push({ "id_utilidad": element.id_utilidad.id_utilidad, "nombre": element.id_utilidad.nombre })
                        }
                    }
                })
                .catch((e) => {
                    console.log(e);
                });

            BasesDataService.getEquivalencias(id)
                .then((response) => {
                    this.equivalenciasBase = response.data;
                })
                .catch((e) => {
                    console.log(e);
                });
        },
        updateBase() {
            this.getNewBase();
            BasesDataService.update(this.newBase.cod_base, this.newBase)
                .then((response) => {
                    BasesDataService.updateEquivalencias(this.newBase.cod_base, this.equivalenciasBase)
                        .then((response) => {
                            BasesDataService.updateUtilidades(this.newBase.cod_base, this.model_utilidad)
                                .then((response) => {
                                    this.setSnack({ message: "Actualizado correctamente", color: "success" });
                                    this.$router.push({ name: "BasesList" });
                                })
                                .catch((e) => {
                                    if (e.response.data.detail) {
                                        this.setSnack({ message: e.response.data.detail, color: "error" });
                                    } else {
                                        this.setSnack({ message: e.message, color: "error" });
                                    }
                                    console.log(e);
                                });
                        })
                        .catch((e) => {
                            if (e.response.data.detail) {
                                this.setSnack({ message: e.response.data.detail, color: "error" });
                            } else {
                                this.setSnack({ message: e.message, color: "error" });
                            }
                            console.log(e);
                        });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        deleteBase() {
            BasesDataService.delete(this.currentBase.cod_base)
                .then((response) => {
                    this.setSnack({ message: "Borrado correctamente", color: "success" });
                    this.$router.push({ name: "BasesList" });
                })
                .catch((e) => {
                    console.log(e);
                    this.setSnack({ message: e.response.data.detail, color: "error" });
                });
        },
        saveBase() {
            this.getNewBase();
            BasesDataService.create(this.newBase)
                .then((response) => {
                    BasesDataService.updateEquivalencias(this.newBase.cod_base, this.equivalenciasBase)
                        .then((response) => {
                            BasesDataService.updateUtilidades(this.newBase.cod_base, this.model_utilidad)
                                .then((response) => {
                                    this.setSnack({ message: "Creado correctamente", color: "success" });
                                    this.$router.push({ name: "BasesList" });
                                })
                                .catch((e) => {
                                    if (e.response.data.detail) {
                                        this.setSnack({ message: e.response.data.detail, color: "error" });
                                    } else {
                                        this.setSnack({ message: e.message, color: "error" });
                                    }
                                    console.log(e);
                                });
                        })
                        .catch((e) => {
                            if (e.response.data.detail) {
                                this.setSnack({ message: e.response.data.detail, color: "error" });
                            } else {
                                this.setSnack({ message: e.message, color: "error" });
                            }
                            console.log(e);
                        });
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
        },
        editEquivalenciasItem(item) {
            this.editedEquivalenciaIndex = this.equivalenciasBase.indexOf(item)
            this.editedEquivalenciaItem = Object.assign({}, item)
            this.editedEquivalenciaDosis.origen = this.editedEquivalenciaItem.dosis.split(':')[0]
            this.editedEquivalenciaDosis.destino = this.editedEquivalenciaItem.dosis.split(':')[1]
            this.dialogEquivalencia = true
        },

        deleteEquivalenciasItem(item) {
            this.editedEquivalenciaIndex = this.equivalenciasBase.indexOf(item)
            this.editedEquivalenciaItem = Object.assign({}, item)
            this.editedEquivalenciaDosis.origen = this.editedEquivalenciaItem.dosis.split(':')[0]
            this.editedEquivalenciaDosis.destino = this.editedEquivalenciaItem.dosis.split(':')[1]
            this.dialogEquivalenciaDelete = true
        },

        deleteEquivalenciaItemConfirm() {
            this.equivalenciasBase.splice(this.editedEquivalenciaIndex, 1)
            this.closeEquivalenciaDelete()
        },
        closeEquivalencia() {
            this.dialogEquivalencia = false
            this.$nextTick(() => {
                this.editedEquivalenciaItem = Object.assign({}, this.defaultEquivalenciaItem)
                this.editedEquivalenciaDosis.origen = 0
                this.editedEquivalenciaDosis.destino = 0
                this.editedEquivalenciaIndex = -1
            })
        },
        closeEquivalenciaDelete() {
            this.dialogEquivalenciaDelete = false
            this.$nextTick(() => {
                this.editedEquivalenciaItem = Object.assign({}, this.defaultEquivalenciaItem)
                this.editedEquivalenciaDosis.origen = 0
                this.editedEquivalenciaDosis.destino = 0
                this.editedEquivalenciaIndex = -1
            })
        },
        saveEquivalencia() {
            if (this.$refs.formEquivalencia.validate()) {
                if (this.editedEquivalenciaIndex < 0) {
                    this.editedEquivalenciaIndex = this.equivalenciasBase.length
                }
                if (this.editedEquivalenciaItem.cod_base_destino_id === '') {
                    this.errorEquivalencias = "Seleccione una Base"
                    return
                }
                if (this.editedEquivalenciaDosis.origen <= 0 || this.editedEquivalenciaDosis.destino <= 0) {
                    this.errorEquivalencias = "Las equivalencias deben ser números positivos"
                    return
                }
                if (this.editedEquivalenciaItem.cod_base_destino_id.cod_base) {
                    this.editedEquivalenciaItem.cod_base_destino_id = this.editedEquivalenciaItem.cod_base_destino_id.cod_base
                }
                this.editedEquivalenciaItem.dosis = this.editedEquivalenciaDosis.origen + ":" + this.editedEquivalenciaDosis.destino
                if (this.editedEquivalenciaIndex < this.equivalenciasBase.length) {
                    Object.assign(this.equivalenciasBase[this.editedEquivalenciaIndex], this.editedEquivalenciaItem)
                } else {
                    this.equivalenciasBase.push(this.editedEquivalenciaItem)
                }
                this.closeEquivalencia()
            } else {
                this.setSnack({ message: "Complete los campos necesarios.", color: "error" });
            }
        },
        saveFamilia() {
            FamiliasDataService.create({ nombre: this.nuevaFamilia })
                .then((response) => {
                    this.setSnack({ message: "Creado correctamente", color: "success" });
                    this.familias.push({ id_familia: response.data.id_familia, nombre: response.data.nombre })
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
            this.closeFamilia();
        },
        closeFamilia() {
            this.dialogFamilia = false
            this.nuevaFamilia = "";
        },
        saveUtilidad() {
            UtilidadesDataService.create({ nombre: this.nuevaUtilidad })
                .then((response) => {
                    this.setSnack({ message: "Creado correctamente", color: "success" });
                    this.utilidades.push({ id_utilidad: response.data.id_utilidad, nombre: response.data.nombre })
                })
                .catch((e) => {
                    if (e.response.data.detail) {
                        this.setSnack({ message: e.response.data.detail, color: "error" });
                    } else {
                        this.setSnack({ message: e.message, color: "error" });
                    }
                    console.log(e);
                });
            this.closeUtilidad();
        },
        closeUtilidad() {
            this.dialogUtilidad = false
            this.nuevaUtilidad = "";
        }
    },
    mounted() {
        this.editing = false;
        if (this.$route.params.id) {
            this.getBase(this.$route.params.id);
            this.editing = true;
        }

        this.isLoading = true
        FamiliasDataService.getSimple()
            .then((response) => {
                this.familias = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))


        BasesDataService.getSimple()
            .then((response) => {
                this.bases = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))

        UtilidadesDataService.getSimple()
            .then((response) => {
                this.utilidades = response.data
            })
            .catch((e) => {
                console.log(e);
            })
            .finally(() => (this.isLoading = false))
    },
    computed: {
        formEquivalenciaTitle() {
            if (this.editedEquivalenciaIndex === -1) {
                return 'Nuevo'
            } else {
                return 'Editar'
            }
        }
    },
    watch: {
        dialogEquivalencia(val) {
            this.editedEquivalenciaItem.cod_base_origen_id = this.currentBase.cod_base
            val || this.closeEquivalencia()
        },
        dialogEquivalenciaDelete(val) {
            val || this.closeEquivalenciaDelete()
        },
        '$route.params.id'(newId, oldId) {
            this.editing = false;
            this.equivalenciasBase = [];
            this.model_utilidad = [];
            this.currentBase = {
                cod_base: "",
                descripcion: "",
                id_familia: null,
                dureza: 0,
                densidad: 0,
                fda: false,
                decimales: 0,
                prioritario: false,
            };
            this.$refs.formEquivalencia.reset();
        }
    }
};
</script>